import { Carousel } from "@ww-digital/prism";
import ContentGutter from "../../ContentGutter";
import SiteWrapper from "../../SiteWrapper";
import t from "../../../utils/translate";
import { useRecipeResults } from "../../../utils/useRecipeResults";

import styles from "./styles.module.scss";

import dairy from "../../RecipeResults/img/dairy.svg";
import gluten from "../../RecipeResults/img/gluten.svg";
import kosher from "../../RecipeResults/img/kosher.svg";
import nuts from "../../RecipeResults/img/nuts.svg";
import vegan from "../../RecipeResults/img/vegan.svg";
import vegetarian from "../../RecipeResults/img/vegetarian.svg";

import recipeFallback from "../../RecipeResults/img/recipe-card-fallback.jpg";

const prepareRecipes = recipes => {
  let result = [];

  if (!recipes) {
    return result;
  }

  recipes.forEach(c => (result = [...result, ...c.items]));

  return result.sort((a, b) => {
    if (a.updatedDate > b.updatedDate) {
      return -1;
    }
    if (a.updatedDate < b.updatedDate) {
      return 1;
    }

    // updatedDates equal, sort by title
    if (a.title < b.title) {
      return -1;
    }
    if (a.title > b.title) {
      return 1;
    }

    return 0;
  });
};

const getRecipeIcon = icons => {
  return icons.map((icon, i) => {
    switch (icon) {
      case "Gluten-Free":
      case "Gluten free":
      case "Glutenvrij":
      case "Sans gluten":
      case "Sem glúten":
      case "Glutenfrei":
      case "Glutenfritt":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={gluten} alt={icon} />
          </div>
        );
      case "Kosher":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={kosher} alt={icon} />
          </div>
        );
      case "Vegan":
      case "Veganistisch":
      case "Végétalien":
      case "Vegana":
      case "Veganskt":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={vegan} alt={icon} />
          </div>
        );
      case "Nut-Free":
      case "Nut free":
      case "Nussfrei":
      case "Sans noix":
      case "Sans fruits à coque":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={nuts} alt={icon} />
          </div>
        );
      case "Vegetarian":
      case "Vegetarisch":
      case "Végétarien":
      case "Vegetariana":
      case "Vegetariskt (lakto-ovo)":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={vegetarian} alt={icon} />
          </div>
        );
      case "Dairy-Free":
      case "Dairy free":
      case "Non laitier":
        return (
          <div className={styles.recipeIcon} key={i}>
            <img src={dairy} alt={icon} />
          </div>
        );
      default:
        return null;
    }
  });
};

const getRecipeCards = recipes =>
  recipes.map((recipe, i) => {
    return {
      children: (
        <div
          className={styles.recipeCard}
          key={i}
          da-category="quiz"
          da-label="quiz:recipe_card"
          da-action="recipe_card"
          aria-label={`${recipe.title}, ${recipe.points} ${t("POINTS_ARIA_LABEL")}, ${recipe.dietary.join(", ")}`}
        >
          <div aria-hidden="true">
            <img
              className={styles.recipeImage}
              src={recipe.image ? recipe.image : recipeFallback}
            />
            <div className={styles.recipeCoin}>{recipe.points}</div>
            <div className={styles.recipeContent}>{recipe.title}</div>
            <div className={styles.recipeIconContainer}>
              {getRecipeIcon(recipe.dietary)}
            </div>
          </div>
        </div>
      )
    };
  });

const RecipeRecommendations = () => {
  const { data: recipes, isLoading } = useRecipeResults();

  if (isLoading || !recipes) {
    return null;
  }

  const sortedRecipes = prepareRecipes(recipes);

  if (sortedRecipes.length < 1) {
    return null;
  }

  return (
    <ContentGutter>
      <SiteWrapper size="small">
        <h2 className={styles.header}>{t("RECIPE_RESULTS_HEADER")}</h2>
        <div className={styles.description}>{t("RECIPE_RESULTS_TEXT")}</div>
        <div className={styles.carouselWrapper}>
          <Carousel
            carouselItems={getRecipeCards(sortedRecipes)}
            carouselItemClassname="carouselSlideFlex"
            options={{
              fixedWidth: "192px",
              gap: "16px",
              type: "loop",
              mediaQuery: "min",
              arrows: false,
              padding: { right: "50px", left: "10px" },
              breakpoints: {
                615: {
                  arrows: true
                }
              }
            }}
            className={styles.carousel}
          />
        </div>
      </SiteWrapper>
    </ContentGutter>
  );
};

export default RecipeRecommendations;
